import React, { createContext, useContext, useState } from 'react';

// Context for managing backroute information
const BackrouteContext = createContext();

// Provider component to wrap layouts
export const BackrouteProvider = ({ children }) => {
  const [backroute, setBackroute] = useState(null);
  const [title, setTitle] = useState(null);
  const [customBackHandler, setCustomBackHandler] = useState(null);

  const updateBackroute = ({
    path = null,
    title: newTitle = null,
    customHandler = null
  }) => {
    setBackroute(path);
    setTitle(newTitle);
    setCustomBackHandler(() => customHandler);
  };

  const resetBackroute = () => {
    setBackroute(null);
    setTitle(null);
    setCustomBackHandler(null);
  };

  return (
    <BackrouteContext.Provider
      value={{
        backroute,
        title,
        customBackHandler,
        updateBackroute,
        resetBackroute,
      }}
    >
      {children}
    </BackrouteContext.Provider>
  );
};

// Hook for child components to set backroute information
export const useBackroute = () => {
  const context = useContext(BackrouteContext);
  if (!context) {
    throw new Error('useBackroute must be used within a BackrouteProvider');
  }
  return context;
};

// Hook for layouts to access backroute information
export const useBackrouteContext = () => {
  const context = useContext(BackrouteContext);
  return context || {};
};